/**
 * The name of the bundled audio file which will be played when e2ee is disabled.
 *
 * @type {string}
 */
export const E2EE_OFF_SOUND_FILE = 'e2eeOff.mp3';

/**
 * The name of the bundled audio file which will be played when e2ee is enabled.
 *
 * @type {string}
 */
export const E2EE_ON_SOUND_FILE = 'e2eeOn.mp3';
